import {
  listAssignees,
  clearBulkAssignData,
  listProducerCodes,
  clearProducerSlotState,
} from "../../../store/renewal/renewalActions";
import BulkUpdateAssigneeForm from "./BulkUpdateAssigneeForm";
import BulkUpdateProducerCodeForm from "./BulkUpdateProducerCodeForm";

export const BulkUpdateActionType = {
  ASSIGNEE: "ASSIGNEE",
  PRODUCER_1: "PRODUCER_1",
  PRODUCER_2: "PRODUCER_2",
};

export const BulkUpdateModalConfig = {
  ASSIGNEE: {
    title: (rows) =>
      rows.length === 1
        ? `Assign renewal for Policy #${rows[0].PolicyNumber} to`
        : `Bulk Assign ${rows.length} renewals to`,

    emptyText: "No eligible assignees found",

    loadTargetsAction: listAssignees,
    clearStateAction: clearBulkAssignData,
    targetsSelector: (state) => state.renewal.assignees,
    loadingSelector: (state) => state.renewal.assigneesLoading,

    FormComponent: BulkUpdateAssigneeForm,
  },

  PRODUCER_1: {
    title: (rows) =>
      rows.length === 1
        ? `Update Producer Code 1 for Policy #${rows[0].PolicyNumber}`
        : `Update Producer Code 1 for ${rows.length} renewals`,

    emptyText: "No eligible producer codes found",

    loadTargetsAction: (keys) => listProducerCodes(keys, 1),
    clearStateAction: () => clearProducerSlotState(1),
    targetsSelector: (state) => state.renewal.bulkProducerTargets?.[1] ?? [],
    loadingSelector: (state) => state.renewal.bulkProducerTargetsLoading?.[1] ?? false,

    FormComponent: BulkUpdateProducerCodeForm,
    producerSlot: 1,
  },

  PRODUCER_2: {
    title: (rows) =>
      rows.length === 1
        ? `Update Producer Code 2 for Policy #${rows[0].PolicyNumber}`
        : `Update Producer Code 2 for ${rows.length} renewals`,

    emptyText: "No eligible producer codes found",

    loadTargetsAction: (keys) => listProducerCodes(keys, 2),
    clearStateAction: () => clearProducerSlotState(2),
    targetsSelector: (state) => state.renewal.bulkProducerTargets?.[2] ?? [],
    loadingSelector: (state) => state.renewal.bulkProducerTargetsLoading?.[2] ?? false,

    FormComponent: BulkUpdateProducerCodeForm,
    producerSlot: 2,
  },
};
